import {
  fetchPublicInstallationOrderById,
  fetchPublicProjectOrderById,
  fetchPublicRemovalOrderById,
} from "components/proejctsandquoteapicalls";
import { normalizeFetchedOrderShape, type PublicOrderNormalizeKind } from "./orderSummaryKinds";

export async function fetchNormalizedPublicOrderForSummary(
  isRemovalPublicSummary: boolean,
  isInstallationPublicSummary: boolean,
  effectiveProjectId: string,
  queryOrderId: string,
  effectiveAccessToken: string
): Promise<any> {
  const data = isRemovalPublicSummary
    ? await fetchPublicRemovalOrderById("", effectiveProjectId, queryOrderId, effectiveAccessToken)
    : isInstallationPublicSummary
      ? await fetchPublicInstallationOrderById("", effectiveProjectId, queryOrderId, effectiveAccessToken)
      : await fetchPublicProjectOrderById("", effectiveProjectId, queryOrderId, effectiveAccessToken);

  const kind: PublicOrderNormalizeKind = isRemovalPublicSummary
    ? "removal"
    : isInstallationPublicSummary
      ? "installation"
      : "sales";

  return normalizeFetchedOrderShape(data, kind);
}
